import { cellEstadoVentaSupervisor, EstadoLiberarVentaENUM, formatDateWithTimeAMPM, gridSizeMdLg6, ModulosEnumChoice, useTableColumnsSolicitudLiberacion, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchPutNuevaLinea, useGetFetchSupervision } from "@/shared/actions/erp/supervision.action";
import { CustomTextArea, CustomTextField, CustomTextFieldNoForm, GeneralTable } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { IDataSolicitudSupercion } from "@/shared/interfaces/erp/supervision/supervision.interface";
import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Grid } from "@mui/material";
import { MRT_RowData } from "material-react-table";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from 'yup';

const newSupervisorVentaSolicitudNuevaLineaSchema = yup.object({
  motivo: yup.string().required('Campo Obligatorio'),
  vendedor: yup.string().required('Campo Obligatorio'),
  id_solicitud_desbloqueo: yup.string().required('Campo Obligatorio'),
})

type ISupervicionVentaFrom = {
  vendedor: string;
  motivo: string;
  id_solicitud_desbloqueo: string;
  fecha_registro?: string;
  estado?: string;
  estado_venta?: string;
  canal_venta_create?: string;
};


const SupervicionVentaSolicitudPage = () => {

  const { columnBase } = useTableColumnsSolicitudLiberacion({
    estado_solicitud: EstadoLiberarVentaENUM.EN_ESPERA
  });

  const [open, setOpen] = useState<boolean>(false);
  //const [dataSolicitudDesblo, setDataSolicitudDesblo] = useState<IDataSolicitudSupercion | null>(null);

  ///* form
  const form = useForm<ISupervicionVentaFrom>({
    resolver: yupResolver(newSupervisorVentaSolicitudNuevaLineaSchema)
  });
  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = form;

  const {
    globalFilter,
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const fetchPutLiberarProspecto = useFetchPutNuevaLinea();

  const { isLoading, data: supervicionRes,
    isRefetching, } = useGetFetchSupervision(
      {
        page: pageIndex + 1,
        page_size: pageSize,
        identificacion: globalFilter,
        estado_solicitud: EstadoLiberarVentaENUM.EN_ESPERA,
        ...filterObject,
        filterByState: false
      }
    );

  const onEdit = (e: MRT_RowData) => {
    const info = e as IDataSolicitudSupercion;
    setOpen(true);

    const resp = cellEstadoVentaSupervisor(info);

    reset({
      vendedor: info.prospecto_data.user_create,
      id_solicitud_desbloqueo: info.id_solicitud_desbloqueo,
      fecha_registro: resp.fecha_registro,
      estado: resp.modulo == ModulosEnumChoice.PREAGENDAMIENTO ? 'EXITO' : 'EN ESPERA',
      estado_venta: resp.modulo,
      canal_venta_create: info.prospecto_data.canal_venta_create
    });
  }


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {/* <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            text=""
          /> */}
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataSolicitudSupercion>
            columns={columnBase}
            data={supervicionRes?.data.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={supervicionRes?.data?.count}
            actionsColumnSize={120}
            onEdit={onEdit}
            canDelete={false}
            positionActionsColumn='first'

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

          />
        </Grid>
      </Grid>
      <ScrollableDialogProps
        onCloseIcon={() => setOpen(false)}
        open={open}
        title="Permitir nueva línea"
        showConfirmBtn={true}
        onConfirm={handleSubmit(async (form) => {
          await fetchPutLiberarProspecto.mutateAsync({
            id_solicitud_desbloqueo: form.id_solicitud_desbloqueo,
            params: {
              motivo: form.motivo,
              estado_solicitud: EstadoLiberarVentaENUM.APROBADO
            },
          });

          setOpen(false);
          reset({});
        })}
        confirmVariantBtn={'contained'}
        showRejectBtn={true}
        onReject={async () => {
          await fetchPutLiberarProspecto.mutateAsync({
            id_solicitud_desbloqueo: form.getValues().id_solicitud_desbloqueo!,
            params: {
              estado_solicitud: EstadoLiberarVentaENUM.CANCELADO
            },
          });

          setOpen(false);
          reset({})
        }}

        onClose={() => {
          setOpen(false)
          reset({})
        }}
        contentNode={

          <Grid container spacing={2}>

            <CustomTextFieldNoForm
              disabled={true}
              label={'Fecha de registro'}
              defaultValue={formatDateWithTimeAMPM(form.getValues().fecha_registro!)}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={'Canal de venta'}
              defaultValue={form.getValues().canal_venta_create}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={'Estado'}
              defaultValue={form.getValues().estado}
              size={gridSizeMdLg6}
            />

            <CustomTextField
              label="Vendedor"
              disabled={true}
              name="vendedor"
              control={form.control}
              defaultValue={form.getValues().vendedor || ''}
              error={errors.vendedor}
              helperText={errors.vendedor?.message}
              size={gridSizeMdLg6}
            />

            <Grid item xs={12}>
              <Alert severity="success">{`El cliente tiene registrado un ${form.getValues().estado_venta}`}</Alert>
            </Grid>


            <CustomTextArea
              label="Motivo"
              name="motivo"
              control={form.control}
              defaultValue={
                form.getValues('motivo') || ''
              }
              error={form.formState.errors.motivo}
              helperText={
                form.formState.errors.motivo?.message
              }
              required={true}
            />

          </Grid>
        }
      />
    </>

  );
}


export default SupervicionVentaSolicitudPage;